import axios from "axios";

const BASE_URL =
    process.env.REACT_APP_API_URL;

// ================= GET ALL SETTLEMENTS =================
export const getAllCateringSettlementsAPI =
    async () => {
        try {
            const token =
                localStorage.getItem(
                    "authToken"
                );

            if (!token) {
                throw new Error(
                    "No auth token found. Please login first."
                );
            }

            const response =
                await axios.get(
                    `${BASE_URL}/catering/api/admin/settlements/all`,
                    {
                        headers: {
                            Authorization:
                                `Bearer ${token}`,

                            Accept:
                                "*/*",
                        },
                    }
                );

            return response.data;

        } catch (error) {
            console.error(
                "❌ Error fetching settlements:",
                error
            );

            throw error;
        }
    };

// ================= APPROVE SETTLEMENT =================
export const approveSettlementAPI =
    async (settlementId) => {
        try {
            const token =
                localStorage.getItem(
                    "authToken"
                );

            if (!token) {
                throw new Error(
                    "Token not found! Please log in again."
                );
            }

            const response =
                await axios.put(
                    `${BASE_URL}/catering/api/admin/settlements/update-status/${settlementId}?paymentStatus=SUCCESS`,
                    {},
                    {
                        headers: {
                            accept:
                                "*/*",

                            Authorization:
                                `Bearer ${token}`,
                        },
                    }
                );

            return response.data;

        } catch (error) {
            console.error(
                "❌ Error approving settlement:",
                error
            );

            throw error;
        }
    };

// ================= GENERATE DATE RANGE =================
export const generateSettlementRangeAPI =
    async (
        fromDate,
        toDate
    ) => {
        try {
            const token =
                localStorage.getItem(
                    "authToken"
                );

            if (!token) {
                throw new Error(
                    "Token not found! Please log in again."
                );
            }

            if (
                !fromDate ||
                !toDate
            ) {
                throw new Error(
                    "Please select both From and To dates"
                );
            }

            const response =
                await axios.post(
                    `${BASE_URL}/catering/api/admin/generate-range?fromDate=${fromDate}&toDate=${toDate}`,
                    {},
                    {
                        headers: {
                            accept:
                                "*/*",

                            Authorization:
                                `Bearer ${token}`,
                        },
                    }
                );

            return response.data;

        } catch (error) {
            console.error(
                "❌ Error generating range:",
                error
            );

            throw error;
        }
    };

export const getAllCateringOrdersAPI =
    async (signal) => {
        try {
            const token =
                localStorage.getItem(
                    "authToken"
                );

            const headers =
                token
                    ? {
                        Authorization:
                            `Bearer ${token}`,
                    }
                    : {};

            const response =
                await fetch(
                    `${BASE_URL}/catering/api/admin/orders/all`,
                    {
                        method:
                            "GET",

                        headers,

                        signal,
                    }
                );

            if (!response.ok) {
                throw new Error(
                    `HTTP error! status: ${response.status}`
                );
            }

            const data =
                await response.json();

            return Array.isArray(data)
                ? data
                : [];

        } catch (error) {
            console.error(
                "❌ Fetching catering orders error:",
                error
            );

            throw error;
        }
    };